import React from 'react';
import { CircularProgress, Grid } from '@mui/material';
import FormattedText from './FormattedText/FormattedText.jsx';
import { useProject } from '../../hooks/useProject.jsx';
import SliderImages from './Slider/SliderImages.jsx';

const ProjectDetails = () => {
    const { projectDescription, projectSliderImages, isSliderLoading } = useProject();

    return (
        <Grid
            container
            sx={{
                height: '100vh',
                maxHeight: '100vh',
                overflow: 'hidden', // Empêche le débordement global
            }}
        >
            {/* Colonne 1 */}
            <Grid
                item
                xs={3} // 1/4 de la largeur
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    overflowY: 'auto', // Overflow uniquement sur cette colonne
                    height: '100%', // Assurez-vous que la hauteur est définie
                    paddingLeft: 10,
                    paddingTop: "10vh"
                }}
            >
                <FormattedText text={projectDescription} />
            </Grid>

            {/* Colonne 2 */}
            <Grid
                item
                xs={8} // 3/4 de la largeur
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%', // Assurez-vous que la hauteur est définie
                    padding: 2,
                    overflowY: 'auto', // Activer le scrolling
                    '&::-webkit-scrollbar': {
                        width: '8px', // Largeur de la scrollbar
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(0, 0, 0, 0.3)', // Couleur de la "thumb"
                        borderRadius: '0px', // Coins arrondis
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Couleur au hover
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: 'transparent', // Fond de la scrollbar
                    },
                }}
            >
                {
                    isSliderLoading ?
                        <div style={{
                            width:"100%",
                            height:"100%",
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"center"
                        }}>
                            <CircularProgress />
                        </div>
                        : <SliderImages images={projectSliderImages} />

                }
            </Grid>
        </Grid>
    );
};

export default ProjectDetails;
